import _ from "ES/lib/lodash";
import React from "ES/lib/react";
import ErrorAlert from "ES/widgets/ErrorAlert";
import MessagePreview from "../../../../marketplace/MyMessagesTab/MessagePreview";
import LoadingWrap from "ES/widgets/LoadingWrap";
import ViewAgreement from "../../../../marketplace/MyLeadsTab/ViewAgreement";
import RadioServiceMixin from "ES/lib/react-pubsub-via-radio.js/RadioServiceMixin";
import getBuyerFirstName from "../../../../../utils/getBuyerFirstName";
import MPJobProgressBar from "../../../../marketplace/MPJobProgressBar";

let Main = function (props) {
    let {
            sid,
            event,
            Displaylists,
            messages,
            mp_agreement
        } = props;

    messages = _.filter(messages, function(msg) {
        // filter out system messages because this is already an event
        return (!_.includes(_.get(msg, ["flags_as_array"]), "system_log"));
    });

    if (!mp_agreement) {
        //old MP events don't have an mp_agreement
        return <div>
            <h4>Messages</h4>
            <MessagePreview thread={messages} sid={sid} eid={_.get(event, ["eid"])} show_send_form={false} />
        </div>;
    }

    let bureau_name = _.find(_.get(Displaylists, "universal.bureaus", []), "bid", event.bureauID.toString());
    bureau_name = _.result(bureau_name, "bname");

    return <div>
        <div className="row">
            <div className="col-sm-12">
                <MPJobProgressBar
                    sid={sid}
                    event={event}
                    startataccepted={true}
                />
                <p className="instruction">
                    This client booked you through <strong>{bureau_name}</strong>. Get a great review from them to turn this engagement into more!
                </p>

                <ViewAgreement
                    event={event}
                    Displaylists={Displaylists}
                    mp_agreement={mp_agreement}
                    display_payments={true}
                />
            </div>
        </div>
        <div className="row">
            <div className="col-sm-12">
                <h4>Messages with {getBuyerFirstName(event)}</h4>
                <MessagePreview thread={messages} sid={sid} eid={_.get(event, ["eid"])} />
            </div>
        </div>
    </div>;
};

module.exports = React.createFactory(React.createClass({
    mixins: [RadioServiceMixin],
    RadioService_setup: function () {
        return {
            Marketplace_getMPMessages: {
                key() {
                    let event = this.props.event || {};
                    return event.eid;
                }
            },
            Marketplace_getMPAgreement: {
                key() {
                    let event = this.props.event || {};
                    return event.eid + "|" + _.first(event.sids);
                }
            }
        };
    },
    componentDidMount: function () {
        this.__loadEvent(this.props.event);
    },
    componentWillReceiveProps: function (next_props) {
        let o_eid = _.get(this.props, ["event", "eid"]);
        let n_eid = _.get(next_props, ["event", "eid"]);
        if (o_eid !== n_eid) {
            this.__loadEvent(next_props.event);
        }
    },
    __loadEvent: function (event) {
        if (!event) {
            return;
        }
        this.RadioService_callService("Marketplace_getMPMessages", {
            event_id: event.eid
        });
        this.RadioService_callService("Marketplace_getMPAgreement", {
            event_id: event.eid,
            speaker_id: _.first(event.sids)
        });
    },
    render: function () {
        let {event, Displaylists} = this.props;
        let sid = _.first(event.sids);

        let ajax_msgs = this.state.Marketplace_getMPMessages;
        let ajax_mpag = this.state.Marketplace_getMPAgreement;

        let mp_agreement = ajax_mpag.data;
        let messages = _.filter(ajax_msgs.data && ajax_msgs.data.messages, function (msg) {
            return (msg.receiver_speaker_id === sid) || (msg.sender_speaker_id === sid);
        });

        let body;
        if (ajax_msgs.waiting || ajax_mpag.waiting) {
            body = LoadingWrap({is_loading: true});
        } else {
            body = <Main
                sid={sid}
                event={event}
                Displaylists={Displaylists}
                messages={messages}
                mp_agreement={mp_agreement}
            />;
        }

        return <div style={{minHeight: 300}}>
            <ErrorAlert message={ajax_msgs.error}/>
            <ErrorAlert message={ajax_mpag.error}/>
            {body}
        </div>;
    }
}));



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/marketplace/index.js